// An advisor's sec_link points at one of two regulator sites, so the anchor text
// has to name whichever one the link actually opens.
export const BROKER_CHECK_LABEL = 'Visit FINRA BrokerCheck Profile'
export const SEC_LABEL = 'Visit SEC Profile'
// Naming neither regulator keeps an unrecognized link from misleading anyone.
export const DEFAULT_LABEL = 'Visit Profile'

const BROKER_CHECK_HOST = 'brokercheck.finra.org'
const SEC_HOST = 'adviserinfo.sec.gov'

const hostnameOf = (link: string): string => {
  try {
    // Some links arrive without a scheme (e.g. "adviserinfo.sec.gov/individual/summary/1"),
    // which URL rejects outright, so add one before parsing.
    const absolute = /^[a-z][a-z0-9+.-]*:\/\//i.test(link) ? link : `https://${link}`
    return new URL(absolute).hostname.toLowerCase()
  } catch {
    return ''
  }
}

const matchesHost = (hostname: string, host: string): boolean =>
  hostname === host || hostname.endsWith(`.${host}`)

/**
 * Resolves the anchor text for an advisor's `sec_link`. Links to FINRA
 * BrokerCheck and to the SEC's adviser-info site get their own copy; anything
 * else (unrecognized host, missing or malformed value) falls back to neutral
 * copy that names no regulator.
 */
const getSecLinkLabel = (link: string | undefined): string => {
  const hostname = hostnameOf(link ?? '')
  if (matchesHost(hostname, BROKER_CHECK_HOST)) return BROKER_CHECK_LABEL
  if (matchesHost(hostname, SEC_HOST)) return SEC_LABEL
  return DEFAULT_LABEL
}

export default getSecLinkLabel
